import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaButtonComponent } from '../../../../shared/ui-kit/pa-button/pa-button.component';
import { FiltersModalService } from 'src/app/core/services/filters-modal.service';
import { ApiService } from 'src/app/core/services/api.service';
import { FilterTypes, FilterValues, FiltersConfig } from 'src/app/shared/models/filter.interface';
import { take } from 'rxjs';
import { getDatesForPeriod } from 'src/app/shared/helpers/date-period.helper';
import { PeriodDateRangeId } from 'src/app/shared/models';

@Component({
  selector: 'app-filters-view',
  templateUrl: './filters-view.component.html',
  styleUrls: ['./filters-view.component.scss'],
  standalone: true,
  imports: [CommonModule, PaButtonComponent],
})
export class FiltersViewComponent {
  private readonly periodOptions = [
    //{ id: PeriodDateRangeId.FIVE_DAYS, name: '5 дней' },
    { id: PeriodDateRangeId.CURRENT_WEEK, name: 'Эта неделя' },
    //{ id: PeriodDateRangeId.WEEK, name: 'Неделя' },
    { id: PeriodDateRangeId.CURRENT_TWO_WEEKS, name: 'Эти 2 недели' },
    //{ id: PeriodDateRangeId.MONTH, name: 'Месяц' },
    { id: PeriodDateRangeId.CURRENT_MONTH, name: 'Этот месяц' },
  ];

  private readonly defaultDateRange = getDatesForPeriod(PeriodDateRangeId.CURRENT_WEEK, new Date())!;
  private currentFilters: FilterValues = { work_period: this.defaultDateRange };

  constructor(
    private readonly filtersModalService: FiltersModalService,
    private readonly api: ApiService,
  ) {}

  openFilters(): void {
    const filtersConfig: FiltersConfig = {
      title: 'Фильтры',
      filters: [
        { 
          dataKey: 'work_period',
          filterType: FilterTypes.DateRange,
          label: 'Период',
          placeholder: 'Выберите период',
          // если нет опций, то будут использоваться опции по умолчанию
          dateRangePeriodOptions: this.periodOptions,
        },
      ],
      savedFilters: this.currentFilters,
      defaultFilters: this.currentFilters,
    };

    this.filtersModalService
      .openFilter(filtersConfig)
      .pipe(take(1))
      .subscribe((result) => {
        if (result?.role === 'saved' && result.data) {
          this.currentFilters = result.data.filters as FilterValues;
          this.api.toastPresent('Фильтры применены');
        }
      });
  }
}
